import React from 'react'
import styles from './ActionButtons.module.scss'
import clsx from 'clsx'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext.tsx'
import {Button, T} from '@colonist/ui'

interface MapReplayButtonProps {
    text: 'strings:game.endGame.cornerButton.mapWithReplay' | 'strings:game.endGame.cornerButton.map'
    className?: string
}

export function MapReplayButton({
    text,
    className,
}: MapReplayButtonProps) {
    const {gameEndData, onClickStatsOrReplay} = useUIGameEndContext()

    return (
        <Button
            className={clsx(styles.button, className)}
            onClick={onClickStatsOrReplay}
            variant='dark'>
            {gameEndData.isReplayAvailable ?
                <T id={{key: text}}/>
                : <T id={{key: 'strings:game.endGame.cornerButton.map'}}/>}
        </Button>
    )
}
